(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tryggupp-cushion-page"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-kg-product]').forEach(root=>{
  if(root.dataset.ready)return;root.dataset.ready='true';
  const thumbs=Array.from(root.querySelectorAll('[data-kg-thumb]')),main=root.querySelector('[data-kg-main]'),zoom=root.querySelector('[data-kg-zoom-dialog]'),zoomImage=root.querySelector('[data-kg-zoom-image]');let index=0,startX=0,startY=0,swiped=false;
  function show(next){index=(next+thumbs.length)%thumbs.length;main.src=thumbs[index].querySelector('img').src;zoomImage.src=main.src;thumbs.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));main.alt='KomfortGel™ produktbild '+(index+1);zoomImage.alt=main.alt}
  thumbs.forEach((button,i)=>button.addEventListener('click',()=>show(i)));root.querySelectorAll('[data-kg-prev]').forEach(b=>b.addEventListener('click',()=>show(index-1)));root.querySelectorAll('[data-kg-next]').forEach(b=>b.addEventListener('click',()=>show(index+1)));
  root.querySelector('[data-kg-zoom]').addEventListener('click',()=>{if(swiped){swiped=false;return}zoom.showModal()});root.querySelector('[data-kg-close]').addEventListener('click',()=>zoom.close());zoom.addEventListener('keydown',e=>{if(e.key==='ArrowRight')show(index+1);if(e.key==='ArrowLeft')show(index-1)});
  const photo=root.querySelector('[data-kg-zoom]');photo.addEventListener('pointerdown',e=>{startX=e.clientX;startY=e.clientY;swiped=false});photo.addEventListener('pointerup',e=>{const dx=e.clientX-startX,dy=e.clientY-startY;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){show(index+(dx<0?1:-1));swiped=true}});
  const form=root.querySelector('[data-kg-buy-form]'),button=form.querySelector('[type=submit]'),error=root.querySelector('[data-kg-error]');form.addEventListener('submit',async e=>{e.preventDefault();if(button.disabled)return;button.disabled=true;error.hidden=true;const quantity=Number(form.querySelector('[name=quantity]:checked').value),id=form.querySelector('[name=id]').value;try{const response=await fetch(window.Shopify.routes.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity}]})});const result=await response.json();if(!response.ok)throw new Error(result.description||'Kudden kunde inte läggas i varukorgen. Försök igen.');window.location.href=window.Shopify.routes.root+'cart'}catch(reason){error.textContent=reason.message;error.hidden=false;button.disabled=false}});
  document.addEventListener('click',event=>{const anchor=event.target.closest('a[href="#kg-buy"]');if(!anchor)return;event.preventDefault();root.querySelector('#kg-buy').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'})});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tryggupp-kampanjrad"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bars = document.querySelectorAll('.tka');
    if (!bars.length) return;
    const wrappers = [];
    bars.forEach((bar) => {
      const wrapper = bar.closest('.shopify-section');
      if (wrapper) {
        wrapper.classList.add('tka-sticky-section');
        wrappers.push(wrapper);
      }
    });
    const header = document.querySelector('.shopify-section-group-header-group') || document.querySelector('.section-header') || document.querySelector('header');
    const updateTop = () => {
      const top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      wrappers.forEach((wrapper) => wrapper.style.setProperty('--tka-top', `${top}px`));
    };
    updateTop();
    window.addEventListener('scroll', updateTop, { passive: true });
    window.addEventListener('resize', updateTop);
    if (header && 'ResizeObserver' in window) new ResizeObserver(updateTop).observe(header);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tryggupp-product-story"] && !Shopify.designMode) return;
  try {
    
  const setupTrygguppStoryVideos = (root = document) => {
    root.querySelectorAll('.tryggupp-story__video-element').forEach((video) => {
      if (video.dataset.trygguppVideoReady === 'true') return;

      video.dataset.trygguppVideoReady = 'true';
      video.muted = true;
      video.controls = false;
      video.disablePictureInPicture = true;
      video.addEventListener('contextmenu', (event) => event.preventDefault());

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
            entry.target.play().catch(() => {});
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: [0, 0.35, 0.75] });

      observer.observe(video);
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.tryggupp-story__review-trigger');
    if (trigger) {
      const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    const closeButton = event.target.closest('.tryggupp-story__review-close');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    if (event.target.matches('.tryggupp-story__review-dialog')) {
      event.target.close();
    }
  });

  const openSubmittedReviewForm = () => {
    document.querySelectorAll('.tryggupp-story__review-dialog').forEach((dialog) => {
      if (dialog.querySelector('.tryggupp-story__form-success, .errors') && !dialog.open) {
        dialog.showModal();
      }
    });
  };

  document.addEventListener('DOMContentLoaded', openSubmittedReviewForm);
  document.addEventListener('DOMContentLoaded', () => setupTrygguppStoryVideos());
  document.addEventListener('shopify:section:load', openSubmittedReviewForm);
  document.addEventListener('shopify:section:load', (event) => setupTrygguppStoryVideos(event.target));
  setupTrygguppStoryVideos();

  } catch(e) { console.error(e); }
})();
})();
